import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    attrs: {
      headers: _vm.tabela.headers,
      items: [_vm.relatorioUnidade],
      "item-key": "id",
      "disable-pagination": "",
      "hide-default-footer": "",
      "show-expand": "",
      "single-expand": "",
    },
    scopedSlots: _vm._u(
      [
        {
          key: `item.data-table-expand`,
          fn: function ({ item, expand, isExpanded }) {
            return [
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                {
                                  attrs: {
                                    height: "100%",
                                    text: "",
                                    width: "100%",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return expand(!isExpanded)
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _c(
                                  VBadge,
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "badge",
                                          fn: function () {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.cargos.length) +
                                                    "/" +
                                                    _vm._s(
                                                      item.funcoes.length
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      VIcon,
                                      {
                                        attrs: {
                                          color: "grey lighten-0",
                                          large: "",
                                        },
                                      },
                                      [_vm._v(" badge ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [_c("span", [_vm._v("Clique para exibir os cargos e funções")])]
              ),
            ]
          },
        },
        {
          key: "expanded-item",
          fn: function ({ headers, item }) {
            return [
              _c(
                "td",
                {
                  staticClass: "justify-center",
                  attrs: { colspan: headers.length },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        [
                          _c(
                            VRow,
                            { staticClass: "justify-center" },
                            [
                              _c("app-title", {
                                attrs: { texto: "CARGOS E FUNÇÕES" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VSimpleTable, {
                            staticClass: "elevation-0 mb-4",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v(" Cargo ")]),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-center",
                                              staticStyle: {
                                                width: "10%",
                                                "min-width": "10%",
                                              },
                                            },
                                            [_vm._v(" Quantidade ")]
                                          ),
                                        ]),
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(item.cargos, function (cargo) {
                                          return _c("tr", { key: cargo.id }, [
                                            _c("td", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row ma-1",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(cargo.nome)),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "text-center" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(cargo.quantidade)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                          ])
                                        }),
                                        0
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VSimpleTable, {
                            staticClass: "elevation-0 mb-4",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v(" Função ")]),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-center",
                                              staticStyle: {
                                                width: "10%",
                                                "min-width": "10%",
                                              },
                                            },
                                            [_vm._v(" Quantidade ")]
                                          ),
                                        ]),
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(item.funcoes, function (funcao) {
                                          return _c("tr", { key: funcao.id }, [
                                            _c("td", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row ma-1",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(funcao.nome)),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "text-center" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(funcao.quantidade)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                          ])
                                        }),
                                        0
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }